import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { Config } from 'src/infrastructure/config';
import { CartLine } from 'src/models/DTO/cart/cartLine';
import { PlainContactV2 } from 'src/models/DTO/contact/plainContactV2';
import { CreatedOrder } from 'src/models/DTO/orders/createdOrder';
import { ImagesService } from 'src/services/request/images/images.service';
import { OrderService } from 'src/services/request/orders/order.service';
import { OrderReturnServiceService } from 'src/services/request/returns/order-return-service.service';
import { HistoryService } from 'src/services/state/history/history.service';
import { ReturnService } from 'src/services/state/return/return.service';

@Component({
  selector: 'app-choose-return',
  templateUrl: './choose-return.component.html',
  styleUrls: ['./choose-return.component.css']
})
export class ChooseReturnComponent extends HistoryBaseComponent implements OnInit {
  private _order?: CreatedOrder;
  private _checkedCartLines: string[] = [];
  private _checkedCartLinesInfo: { [k: string]: number[] } = {};
  public productsFromCartLine = [];

  constructor(
    private ordersService: OrderService,
    private imagesService: ImagesService,
    private router: Router,
    private returnState: ReturnService,
    private toastrService: ToastrService,
    private activatedRoute: ActivatedRoute,
    private orderReturnService: OrderReturnServiceService,
    protected location: Location,
    protected historyService: HistoryService
  ) {
    super(location, historyService);
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      this.loadOrder(params.id);
    });
  }

  private loadOrder(orderUUID: string): void {
    this.ordersService.getOrder(orderUUID).subscribe((order) => {
      this._order = order;

      order.data.lines.findIndex((product) => {
        this.imagesService.getImagesForProduct('PRODUCT', product.sku.product.uuid).subscribe((images) => {
          product.imageSource = images.data[0].original.url;
        });

        return false;
      });
    });
  }

  get order(): CreatedOrder | undefined {
    return this._order;
  }

  get checkedCartLines(): string[] {
    return this._checkedCartLines;
  }

  public returnArrayFromNumbers(length: number): any[] {
    return new Array(length);
  }

  public getUnitPriceBase(cartLine: CartLine): number {
    return Number(cartLine?.price_per_piece) || 0;
  }

  public getPriceAsFixedString(cartLine: CartLine): string[] | string {
    if (!cartLine.price_per_piece) {
      return '00.00';
    }

    const priceCalculated = Number.parseFloat(cartLine.price_per_piece);
    const fixedPrice = priceCalculated.toFixed(2);
    const priceArray = fixedPrice.split('.');

    priceArray[0] = priceArray[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return priceArray;
  }

  public getTotalPriceAsFixedString(price: string): string {
    if (!price) {
      return '00.00';
    }

    const fixedPrice = Number.parseFloat(price).toFixed(2);
    const priceArray = fixedPrice.split('.');

    priceArray[0] = priceArray[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return priceArray[0] + '.' + priceArray[1];
  }

  public getAddressString(address: PlainContactV2): string {
    if (Config.invoiceCompanyLocationRole == address.type.label) {
      return address.city + ', ' + address.address_line_2 + ', ' + address.post_code;
    }

    return address.street_name + ' '
      + address.street_number + ', '
      + ((address.address_line_2) ? (address.address_line_2 + ', ') : '')
      + address.city + ', '
      + ((address.post_code) ? address.post_code : '');
  }

  public returnOptionValue(option: any): string {
    if (option.option.values.length) {
      const optionSelected = option.option.values.find((value: { uuid: any }) => value.uuid == option.value);
      return optionSelected.value;
    }

    return option.value;
  }

  public pricingInfo(cartLine: CartLine): string {
    const price = cartLine.price_per_piece;
    const priceAsString = Number.parseFloat(price).toFixed(2);

    return cartLine.quantity + ' x ' + priceAsString;
  }

  public goToProduct(productPerOrg: CartLine): void {
    if (productPerOrg.sku.product.deleted_at) {
      this.toastrService.info('Продуктът вече не е наличен.');
      return;
    }

    this.router.navigate(['product/' + productPerOrg.sku.product.uuid + '/' + 'none']);
  }

  public toggleCheckCartLine(productPerOrg: CartLine, i: number): void {
    const lineKey = productPerOrg.uuid + '_' + i;
    const exists = this._checkedCartLines.find((cartLine) => cartLine == lineKey);

    if (exists) {
      this._checkedCartLines = this._checkedCartLines.filter((cartLine) => cartLine != lineKey);

      if (this._checkedCartLinesInfo[productPerOrg.uuid]) {
        this._checkedCartLinesInfo[productPerOrg.uuid] =
          this._checkedCartLinesInfo[productPerOrg.uuid].filter((id) => id !== i);

        if (!this._checkedCartLinesInfo[productPerOrg.uuid].length) {
          delete this._checkedCartLinesInfo[productPerOrg.uuid];
        }
      }

      return;
    }

    if (!Object.keys(this._checkedCartLinesInfo).includes(productPerOrg.uuid)) {
      this._checkedCartLinesInfo[productPerOrg.uuid] = [];
    }

    this._checkedCartLines.push(lineKey);
    this._checkedCartLinesInfo[productPerOrg.uuid].push(i);
  }

  public checkIfLineIsChecked(productPerOrg: CartLine, i: number): boolean {
    return !!this._checkedCartLines.find((cartLine) => cartLine == productPerOrg.uuid + '_' + i);
  }

  public continue(): void {
    this.returnState.addNewOrderInfo({
      reason: '',
      iban: '',
      bank: '',
      name: '',
      cartLines: this._checkedCartLinesInfo
    });

    this.router.navigate(['return/choose/reason/' + this.order?.data.uuid + '/' + this._checkedCartLines[0]]);
  }
}
